function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "cubes-4_svg__a",
  x1: "-1.333%",
  x2: "101.333%",
  y1: "50%",
  y2: "50%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#DEFC00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#50CC5D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "cubes-4_svg__b",
  x1: "-.667%",
  x2: "-100%",
  y1: "50%",
  y2: "50%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#DEFC00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#50CC5D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "cubes-4_svg__c",
  x1: "-1.333%",
  x2: "101.333%",
  y1: "50%",
  y2: "50%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#DEFC00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#50CC5D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "cubes-4_svg__d",
  x1: "-.667%",
  x2: "100.667%",
  y1: "50%",
  y2: "50%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#DEFC00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#50CC5D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "cubes-4_svg__e",
  x1: "-1.333%",
  x2: "101.333%",
  y1: "50.002%",
  y2: "50.002%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#DEFC00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#50CC5D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "cubes-4_svg__f",
  x1: "-1.333%",
  x2: "101.333%",
  y1: "50.005%",
  y2: "50.005%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#DEFC00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#50CC5D"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  stroke: "url(#cubes-4_svg__a)",
  d: "M225 311.22V161.6l75-43.3v192.92",
  transform: "translate(1 1)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#cubes-4_svg__b)",
  d: "M225 161.6l-75-43.3L225 75l75 43.3z",
  transform: "translate(1 1)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#cubes-4_svg__a)",
  d: "M150 193.3v-75l75 43.3v149.62",
  transform: "translate(1 1)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#cubes-4_svg__c)",
  d: "M75 311.22V86.6l75-43.3v150",
  transform: "translate(1 1)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#cubes-4_svg__d)",
  d: "M75 86.6L0 43.3 75 0l75 43.3z",
  transform: "translate(1 1)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#cubes-4_svg__e)",
  d: "M0 331.23V43.3l75 43.3v224.62",
  transform: "translate(1 1)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#cubes-4_svg__f)",
  d: "M150 331.23V279.9l75-43.3v74.62",
  transform: "translate(1 1)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#cubes-4_svg__d)",
  d: "M150 279.9l-75-43.3 75-43.3 75 43.3z",
  transform: "translate(1 1)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#cubes-4_svg__f)",
  d: "M75 311.22V236.6l75 43.3v51.33",
  transform: "translate(1 1)"
}));

function SvgCubes4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 302,
    height: 334
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,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";
export { SvgCubes4 as ReactComponent };